import { getAPIUrl } from '../helpers/App';

export const APIsearch = (search, extraParams) => (
  window.axios.get(getAPIUrl('/search'), { params: { search, ...extraParams } })
    .then(response => (response))
);
